// Animations — Terminal, Scroll Reveal

import { prefersReducedMotion } from '../../shared/js/utils/index.js';

// ============================================
// Scroll Reveal (Option D .rv elements)
// ============================================

export function initScrollAnimations() {
    if (prefersReducedMotion()) {
        // Make all .rv elements visible immediately
        document.querySelectorAll('.rv').forEach(el => el.classList.add('vis'));
        return;
    }
    const els = document.querySelectorAll('.rv');
    if (!els.length) return;

    const obs = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
                setTimeout(() => entry.target.classList.add('vis'), i * 60);
                obs.unobserve(entry.target);
            }
        });
    }, { threshold: 0.06 });

    els.forEach(el => obs.observe(el));
}

// ============================================
// Terminal Animation (Hero section)
// ============================================

/*
 * Generated from a real CLI run, not written by hand. Regenerate with:
 *
 *   python CgmToSvgConverter/scripts/generate_hero_transcript.py --cli <path> --out termlines.js
 *
 * Every value here came out of the binary. The only substitution is the output path,
 * because the real run writes to a temp directory. That is the point of generating
 * it: the previous transcript had invented timings, a single-line rendering of a
 * warning the logger emits over two, and a per-file list the tool does not print
 * when a human is watching.
 *
 * `bar: true` marks the progress frames, which REPLACE each other rather than
 * stacking. Spectre takes over the console when it is interactive and redraws one
 * row in place; only the redirected fallback prints a line per file, and nobody
 * running a conversion sees that.
 */
const termLines = [
  { d: 0,    h: `<div><span class="tp">C:\\Reforge&gt;</span> <span class="tc">reforge-cli convert .\\input\\*.cgm --output .\\output --preset s1000d</span></div>` },
  { d: 700,  h: `<div>&nbsp;</div>` },
  { d: 1220, bar: true, h: `<div class="tbar"><span class="tc">Converting</span> <span class="td">15/43</span> <span class="tok">━━━━━━━━━</span><span class="td">━━━━━━━━━━━━━━━━━━━</span> <span class="tc">34%</span></div>` },
  { d: 1740, bar: true, h: `<div class="tbar"><span class="tc">Converting</span> <span class="td">34/43</span> <span class="tok">━━━━━━━━━━━━━━━━━━━━━━</span><span class="td">━━━━━━</span> <span class="tc">79%</span></div>` },
  { d: 2260, bar: true, h: `<div class="tbar"><span class="tc">Converting</span> <span class="td">41/43</span> <span class="tok">━━━━━━━━━━━━━━━━━━━━━━━━━━━</span><span class="td">━</span> <span class="tc">95%</span></div>` },
  { d: 2780, bar: true, h: `<div class="tbar"><span class="tc">Converting</span> <span class="td">43/43</span> <span class="tok">━━━━━━━━━━━━━━━━━━━━━━━━━━━━</span><span class="td"></span> <span class="tc">100%</span></div>` },
  { d: 3380, h: `<div>&nbsp;</div>` },
  { d: 3530, h: `<div><span class="tw">Converted 43/43 files  [✓] 43  [0.44s]</span></div>` },
  { d: 3780, h: `<div><span class="td">Output Location → C:\\TechPubs\\output</span></div>` },
  { d: 4430, h: `<div>&nbsp;</div><div><span class="tp">C:\\Reforge&gt;</span> <span class="tcur"></span></div>` },
];

function runTerminal(tOut) {
    // Painted from the transcript alone. The command used to live here AND in the
    // page's static markup, which is how one copy grew a trailing slash on the
    // profile argument and the other did not - visible only from the second loop
    // onward. One source now.
    tOut.innerHTML = '';

    termLines.forEach(({ d, h, bar }) => {
        setTimeout(() => {
            const cur = tOut.querySelector('.tcur');
            if (cur) cur.closest('div')?.remove();
            // Progress frames redraw in place, the way the live display does.
            if (bar) tOut.querySelector('.tbar')?.remove();
            tOut.insertAdjacentHTML('beforeend', h);
            tOut.scrollTop = tOut.scrollHeight;

        }, d);
    });
}

/** Paint the transcript the animation ends on, with no timers. */
function renderTerminalFinalFrame(tOut) {
    // Only the last progress frame: the bars supersede one another, so painting them
    // all would show four stacked bars the animation never displays together.
    const lastBar = termLines.map((l) => l.bar).lastIndexOf(true);
    const frames = termLines.filter((l, i) => !l.bar || i === lastBar);
    tOut.innerHTML = frames.map(({ h }) => h).join('');
}

export function initTerminal() {
    const tOut = document.getElementById('term-out');
    if (!tOut) return;

    // Reduced motion used to leave the terminal empty but for its prompt — roughly
    // 300px of blank box where the hero's product demo should be. Show the finished
    // transcript instead, the same way initScrollAnimations jumps straight to its
    // end state.
    if (prefersReducedMotion()) {
        renderTerminalFinalFrame(tOut);
        return;
    }

    runTerminal(tOut);

    // runTerminal clears and repaints, so the loop no longer restates the opening
    // line - which is what let the two copies drift apart.
    setInterval(() => runTerminal(tOut), 12000);
}
